import React, {useContext, useEffect, useRef, useState} from "react";
import { ActivityIndicator, WingBlank, Modal, NoticeBar} from 'antd-mobile';
import {PublicRoot} from "../App";
import {ClientBridge} from "../index";


// todo pick from & replyTo from profile



export default function StepThree({
      template,
      adStatus, setAdStatus,
      company,
      setBlackAndWhite, blackAndWhite, ...props}
      ) {

    const publicRoot = useContext(PublicRoot);
    const renderTimer = useRef(null);
    //const [localBnw, setLocalBnw] = useState();
    const [specAd, setSpecAd] = useState('');
    const clientBridge = useContext(ClientBridge);

    /*
    useEffect(()=>{
        setLocalBnw(blackAndWhite);
    },[blackAndWhite]);
     */

    useEffect(()=>{
        // wrap whole thing in self running function so we don't return a promise to useEffect
        ( async ()=>{
            if (adStatus==='building...') {

                console.log('Render... '+template.name);
                if (clientBridge.connected) {
                    //todo make this a async hook
                    // roll specAdStatus in
                    try {
                        const previewUrl = await clientBridge.wizard.mobileRender(template);
                        setSpecAd({previewUrl});
                        setAdStatus('done');
                    } catch (e) {
                        console.error('render failed: '+template.name);
                        console.dir(e);
                        setAdStatus('failed');
                    }
                } else {
                    renderTimer.current = setTimeout(() => {
                        setSpecAd({previewUrl: `${publicRoot}/images/specad.jpg`});
                        setAdStatus('done');
                    }, 2000);
                }
            } else {
                //console.log('clearing timer - not building');
                clearTimeout(renderTimer.current);
            }
            return () => {
                //console.log('clearing timer - new template');
                clearTimeout(renderTimer.current);
            }
        })();
    },[adStatus,setAdStatus, template,  clientBridge,publicRoot]);


/*
    const onClick=(obj, index) =>
        Modal.alert(
            template && template.name,
            <WingBlank size={'sm'}>
                <img
                    src={`${publicRoot}/images/specad.jpg`}
                    alt={template && template.name}
                    style={{width:'100%'}}
                />
                <SingleSwitch
                    checked={localBnw}
                    onChange={() => {setLocalBnw(!localBnw)}}
                >Black & White</SingleSwitch>
            </WingBlank>,
            [
                { text: 'Cancel', onPress: () => console.log('cancel') },
                { text: 'Re-build Ad', onPress: () => {
                        setBlackAndWhite(localBnw);
                        setAdStatus('building...');
                    }},
            ]
        );
 */

    return <WingBlank  style={{marginTop:'5px'}}>
        {
            template && adStatus !== 'done' &&
            <img
                src={template.getPreviewUrl()}
                alt={'Spec Ad'}
                style={{maxWidth: '100%'}}
            />
        }
        {
            {
                '': <div style={{height:'100%'}}>
                    {company.name ? '': <div style={{color: 'red'}}>Missing company name</div>}
                    {template ? '' :  <div style={{color: 'red'}}>No template selected</div>}
                </div>,
                'building...': <Modal
                    visible={true}
                    transparent
                    maskClosable={false}
                    //onClose={this.onClose('modal1')}
                    footer={[{
                        text: 'Cancel', onPress: () => {
                            setAdStatus('canceled')
                        }
                    }]}
                >
                    <img src={publicRoot + '/images/wizard-wand-dust.gif'} alt={'building...'}/>
                    <div>Building {blackAndWhite && 'black and white '}spec ad {template && template.name} for {company.name} ...</div>
                </Modal>,
                'done': <img
                    src={specAd.previewUrl}
                    alt={'Spec Ad'}
                    style={{maxWidth: '100%'}}
                />,
                'failed': <NoticeBar mode="closable">Spec Ad generation failed</NoticeBar>,
                'canceled': <div style={{color: 'red'}}>Spec Ad generation canceled</div>
            }[adStatus]
        }
    </WingBlank>;
};

/*
        <WhiteSpace/>

        <Button
            icon={<Icon icon={fileSyncOutlined}/>}
            inline //size="small"
            style={{marginRight: '4px'}}
            loading={adStatus === 'building...'}
            disabled={adStatus === 'building...' || !template  || ! company.name}
            onClick={onClick}
        >Re-build Ad</Button>
        */